import * as _4 from 'lodash4';

export class PathTitleColorService {
  private colors: object;
  private usedColors: boolean[];

  constructor() {
    this.colors = {};
    this.usedColors = Array(12);
    _4.fill(this.usedColors, false);
  }

  getColor(category: object | string | number): number {
    const index = JSON.stringify(category);

    if (!_4.isUndefined(this.colors[index])) {
      return this.colors[index];
    }

    const charSum = _4.reduce(
      index.split(''),
      (total: number, char) => {
        return total + char.charCodeAt(0);
      },
      0
    );

    let colorCode = charSum % 12;
    if (this.usedColors[colorCode]) {
      colorCode = this.getAvailableColor(colorCode);
    }

    this.usedColors[colorCode] = true;
    this.colors[index] = colorCode + 1;
    return this.colors[index];
  }

  getAvailableColor(colorCode: number): number {
    const newColor = _4.indexOf(this.usedColors, false);
    if (newColor === -1) {
      _4.fill(this.usedColors, false);
      return colorCode;
    }
    return newColor;
  }

  getTextColorClass(category: object | string | number): string {
    return `clr-${this.getColor(category)}-txt`;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/services/path_color_service.ts